// ---------------------------------------------- modules import
import { IOrderedUser } from "../firebase/common";
import { newPermissions } from "../helpers/permissionHelper";
import { newTags } from "../helpers/tagHelper";

export interface IUser extends IOrderedUser {
  password: string;
  [key: string]: any;
}

export const newUser = (): IUser => ({
  id: "",
  name: "",
  email: "",
  password: "",
  permissions: newPermissions(),
  tags: newTags(),
  isSuper: false,
  themeIndex: 0
});

// ---------------------------------------------- state interface
export interface IUserState {
  loading: boolean;
  error: string | null;
}

// ---------------------------------------------- action type enum
export enum UserActionType {
  ADD_USER_BEGIN = "ADD_USER_BEGIN",
  ADD_USER_SUCCESS = "ADD_USER_SUCCESS",
  ADD_USER_ERROR = "ADD_USER_ERROR",
  UPDATE_USER_BEGIN = "UPDATE_USER_BEGIN",
  UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS",
  UPDATE_USER_ERROR = "UPDATE_USER_ERROR",
  DELETE_USER_BEGIN = "DELETE_USER_BEGIN",
  DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS",
  DELETE_USER_ERROR = "DELETE_USER_ERROR"
}

// ---------------------------------------------- action interfaces
interface IAddBegin {
  type: typeof UserActionType.ADD_USER_BEGIN;
}

interface IAddSuccess {
  type: typeof UserActionType.ADD_USER_SUCCESS;
}

interface IAddError {
  type: typeof UserActionType.ADD_USER_ERROR;
  payload: {
    error: string;
  };
}

interface IUpdateBegin {
  type: typeof UserActionType.UPDATE_USER_BEGIN;
}

interface IUpdateSuccess {
  type: typeof UserActionType.UPDATE_USER_SUCCESS;
}

interface IUpdateError {
  type: typeof UserActionType.UPDATE_USER_ERROR;
  payload: {
    error: string;
  };
}

interface IDeleteBegin {
  type: typeof UserActionType.DELETE_USER_BEGIN;
}

interface IDeleteSuccess {
  type: typeof UserActionType.DELETE_USER_SUCCESS;
}

interface IDeleteError {
  type: typeof UserActionType.DELETE_USER_ERROR;
  payload: {
    error: string;
  };
}

// ---------------------------------------------- exported action type
export type UserAction =
  | IAddBegin
  | IAddSuccess
  | IAddError
  | IUpdateBegin
  | IUpdateSuccess
  | IUpdateError
  | IDeleteBegin
  | IDeleteSuccess
  | IDeleteError;
